import React from 'react';
import ChatInput from '../../Components/ChatInput';
import ResponseContainer from '../../Components/ResponseContainer';
import { useChatContext } from '../../Context/ChatContext';
import { useTheme } from '../../Context/ThemeContext';
import { useRole } from '../../Context/RoleContext';
import './index.css';

const Home = () => {
  const { messages } = useChatContext();
  const { isDarkMode } = useTheme();
  const { firstName } = useRole();
  const isEmpty = messages.length === 0;

  const greeting = firstName
    ? `${firstName}, Welcome back. How can I help?`
    : 'Welcome back. How can I help?';

  return (
    <main className={`home ${isDarkMode ? 'dark-mode' : ''}`}>
      <section className={`chat-section ${isEmpty ? 'empty-chat' : ''}`}>
        <div className={`chat-container ${isDarkMode ? 'dark-mode' : ''}`}>
          {isEmpty ? (
            <div className="centered-chat-input">
              <h1 className="help-heading">{greeting}</h1>
              <ChatInput />
            </div>
          ) : (
            <>
              <ResponseContainer />
              <ChatInput />
            </>
          )}
        </div>
      </section>
    </main>
  );
};

export default Home;